var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-cardsmallroom"},[_c('img',{staticClass:"img-cardsmallroom",attrs:{"src":_vm.item[0].url,"alt":"Photo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }